/* 孫尚香（弓腰姬） */
import { spMul, sigOf } from '../../core/kit.ts';
import type { Unit } from '../types.ts';
import { defineHero, hook, D } from '../define.ts';

export default defineHero({
  id: 'sunshangxiang', name: '孫尚香', sub: '弓腰姬', faction: 'wu', role: '射手', weapon: 'bow',
  look: { female: true, head: 'bun', size: 0.96, fx: '#ff9ab0', c: { cloth: '#c4453a', sleeve: '#c4453a', armor: '#e9c46a', flower: '#ffcf6a', pole: '#8a2a22' } },
  skills: [
    ['梟姬箭', 'bolt', '射出一箭，命中第一個敵人造成 {70/110/150/190} 傷害，並讓自己移速 +{10/13/15/18}% 2 秒。', { x: { k: 'owlshot', dmg: [70, 110, 150, 190], ms: [10, 13, 15, 18] }, aim: D(750, 18), el: null }],
    ['翻身', 'blink', '翻身位移 {300/350/400/450} 距離並解除緩速。', { sig: 'tumble', aim: { kind: 'point', range: [300, 350, 400, 450], area: 0 } }],
    ['弓腰姬', 'passive', '每次普攻命中，攻速再加 {6/8/10/12}%，最多疊 4 層（{24/32/40/48}%）；3 秒沒有普攻就歸零。', { pv: {}, sig: 'archer', as: [6, 8, 10, 12], stack: 'archerN', max: 4 }], // v0.4.2：原本加射程，跟馬岱重疊
    ['梟姬箭雨', 'volley', '箭雨覆蓋區域，每秒 {95/145/195} 傷害並緩速 30%；落下的瞬間定身 {0.8/1/1.2} 秒。'],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 孫尚香「梟姬箭」：命中第一個敵人後自己加速
    owlshot(u, a, X) {
      const sp = spMul(u);
      this.shootProj(u, { dir: a.dir, speed: 1100, range: this.skillRange(a.sk, a.lvl), rad: 16, shape: 'arrow', col: u.spec.fx, big: true,
        onHit: (t: Unit) => { this.damage(u, t, X.dmg * sp, { magic: true, spell: true, stagger: 0.2 }); this.addBuff(u, { id: a.sk.name, t: 2, ms: X.ms / 100 }); return true; } });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 弓腰姬：普攻命中疊攻速，最多 4 層；buff 3 秒沒刷新就消失，層數跟著歸零
    hook('onHit', 30, function (u, t) {
      const g = sigOf(u, 'archer');
      if (!g) return;
      const b = u.buffs && u.buffs.find((o: any) => o.id === '弓腰姬'), n = Math.min(4, (b ? b.n : 0) + 1);
      this.addBuff(u, { id: '弓腰姬', t: 3, as: g.v('as') * n, n });
      u.archerN = n; // 層數（技能按鈕顯示）
    }),
    // 弓腰姬：buff 消失時層數歸零
    hook('tick', 60, function (u, dt) { if (u.archerN && !(u.buffs && u.buffs.some((b: any) => b.id === '弓腰姬' && b.t > 0))) u.archerN = 0; }),
    // 翻身：解除緩速
    hook('cast.after', 40, function (u, i, sk) { if (sk && sk.sig === 'tumble') { u.st.slow = 0; if (u.buffs) { u.buffs = u.buffs.filter((b: any) => !(b.neg && b.ms < 0)); this.addBuff(u, { id: 'tumble', t: 0.01 }); } } }),
  ],
  // 電腦什麼時候放這招
  ai: {
    owlshot: ({ w, u, t, d, hero, hpR, foeHeroes }) => !!t && d < 720 && (hero || u.mp > u.maxMp * 0.6),
  },
});
